import { Injectable } from '@angular/core';
import { DeviceData } from '../../../_models/deviceData';
import { LoraChart } from '../../../../../assets/data/enum/loraChart.enum';

@Injectable()
export class LoraChartDataService {
  private loraData = {};
  private cache: Map<string, DeviceData> = new Map();

  constructor() {}

  /* LORA DATA */
  /* LORA DATA */
  setLoraData(loraData): void {
    this.loraData = loraData;
  }

  getLoraData() {
    return this.loraData;
  }

  /* LORA CHART */
  setLoraChart(loraChart: string, newLoraChart): void {
    const loraData = this.getLoraData();
    loraData[loraChart] = newLoraChart;
    this.setLoraData(loraData);
  }

  getLoraChart(loraChart: string) {
    const loraData = this.getLoraData();
    return loraData[loraChart];
  }

  resetLoraChart(loraChart: string) {
    this.setLoraChart(loraChart, {});
  }

  /* LORA CHART DATA */
  setLoraChartData(code: string, loraChart: string, newLoraChartData): void {
    this.assureLoraChartExists(loraChart);

    const loraData = this.getLoraData();
    loraData[loraChart][code] = newLoraChartData;
    this.setLoraData(loraData);
  }

  getLoraChartData(code: string, loraChart: string) {
    this.assureLoraChartExists(loraChart);

    const loraData = this.getLoraData();
    return loraData[loraChart][code];
  }

  addValueToLoraChartData(
    code: string,
    loraChart: string,
    value: any,
    currentTime: number,
    addToTotal: boolean
  ) {
    if (value && value !== null) {
      const ITEM = [currentTime, value];
      this.addItemToLoraChartData(code, loraChart, ITEM);

      if (addToTotal) {
        this.addToLoraDataTotalPerDevice(code, loraChart, value);
      }
    }
  }

  addItemToLoraChartData(code: string, loraChart: string, item: any) {
    this.assureLoraChartDataExists(code, loraChart, true);

    const loraData = this.getLoraData();
    loraData[loraChart][code].push(item);
    this.setLoraData(loraData);
  }

  resetLoraChartData(code: string, loraChart: string, asArray: boolean) {
    this.setLoraChartData(code, loraChart, asArray ? [] : {});
  }

  /* CACHE */
  /* CAHCE */
  setCache(cache: Map<string, DeviceData>): void {
    this.cache = cache;
  }

  getCache() {
    return this.cache;
  }

  /* CAHCE ITEM */
  setCacheItem(code: string, deviceData: DeviceData): void {
    let cache: Map<string, DeviceData> = this.getCache();
    if (!cache) {
      cache = new Map();
    }
    cache.set(code, deviceData);
    this.setCache(cache);
  }

  getCacheItem(code: string): DeviceData {
    let cache: Map<string, DeviceData> = this.getCache();
    if (!cache) {
      cache = new Map();
    }
    return cache.get(code);
  }

  private assureLoraChartExists(loraChart: string) {
    const loraData = this.getLoraData();

    if (!loraData[loraChart]) {
      this.setLoraChart(loraChart, {});
    }
  }

  private assureLoraChartDataExists(code: string, loraChart: string, asArray: boolean) {
    this.assureLoraChartExists(loraChart);

    const loraData = this.getLoraData();
    if (!loraData[loraChart][code]) {
      this.resetLoraChartData(code, loraChart, asArray);
    }
  }

  private addToLoraDataTotalPerDevice(code: string, loraChart: string, value: any) {
    this.assureLoraChartDataExists(code, LoraChart.TotalPerDevice, false);

    const loraData = this.getLoraData();
    if (!loraData[LoraChart.TotalPerDevice][code][loraChart]) {
      loraData[LoraChart.TotalPerDevice][code][loraChart] = [value];
    } else {
      loraData[LoraChart.TotalPerDevice][code][loraChart].push(value);
    }
    this.setLoraData(loraData);
  }
}
